import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root',
})
export class AddToHomeScreenService {

  // deferredPrompt is a public behaviourSubject, this functions as an observable, 
  // but we have control of when it emits values, we can then subscribe to this in consumers of this service
  public deferredPrompt: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private readonly toastrService: ToastrService
    ) {}

  addToHomeScreen(event: any): void {
    // Prevent default behaviour
    event.preventDefault();

    // Emit event as observable on deferredPrompt
    this.deferredPrompt.next(event);
  }


  promptFunction() {
    // Get current value from behaviour subject
    const prompt = this.deferredPrompt.getValue();
    
    // Show the prompt
    prompt.prompt();

    // Wait for the user to respond to the prompt
    prompt.userChoice
      .then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          // Do something when installation accepted
          this.toastrService.success("A shortcut has been added to your Home Screen/Desktop");
        } else {
          // Do something when installation not accepted
        }

        // Clear current deferredPrompt
        this.deferredPrompt.next(null);
      });

  }

}